/**
 * Format duration (seconds) → "2h 15m" / "45 min" / "7 min"
 */
export const formatDuration = (seconds) => {
  if (!seconds || seconds < 1) return null;

  const totalMinutes = Math.round(seconds / 60);

  if (totalMinutes < 60) return `${totalMinutes} min`;

  const hours = Math.floor(totalMinutes / 60);
  const mins = totalMinutes % 60;
  return mins === 0 ? `${hours}h` : `${hours}h ${mins}m`;
};
